import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

const Section = ({ children, className }) => (
  <section className={`py-12 sm:py-16 md:py-20 ${className || ''}  lg:px-14`}>
    <Box className="container ">{children}</Box>
  </section>
);

Section.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Section;
